export default "__VITE_ASSET__HlGYlFZJ__"